import { DropdownContentData } from '@legacyApp/client/store/dropdown/dropdown.reducer';
import transactionService from '@modules/transactions/transactionsService';

export const dropdownContentEqualityFn = (
	a: DropdownContentData,
	b: DropdownContentData,
) => {
	return !transactionService.isListDifferent(a?.items, b?.items, [
		'id',
		'name',
		'value',
		'disabled',
		'className',
	]);
};
